
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/delta-3-air-series-portable-power-station/support",
      function () {
        return require("private-next-pages/delta-3-air-series-portable-power-station/support/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/delta-3-air-series-portable-power-station/support"])
      });
    }
  